export const isUserAuthenticated = ({ account }: { account: AccountState }): boolean => !!account.user;

export const getUserEmail = ({ account }: { account: AccountState }): string | null => {
    return account.user ? account.user.email : null;
};

export default { isUserAuthenticated, getUserEmail };
